export const otpFieldContainerStyles = `flex flex-col items-center w-full`

export const otpBoxesFieldContainerStyles = `self-start w-full`

export const resendOTPWithOTPTimerContainerStyles = `flex justify-between w-full items-center mt-2`

export const otpTimerTextStyles = `text-sm-semibold select-none text-right`

export const resendOTPAndCallContainerStyles = `flex flex-col items-center`

export const resendOTPTextContainerStyles = `flex`

export const resendOtpTextStyles = `pointer-events-none text-sm-semibold pl-auto mr-[5px]`

export const otpInputStyles = `!w-[44px] h-[44px] border-[1px] shadow-[0_1px_2px_rgba(0,0,0,0.08)] text-sm-medium rounded-xl last-child:!mr-0`

export const otpInputFocusStyles = `opacity-90 focus:!border-[2px] focus:outline-0 focus:outline-offset-0 focus:shadow-[0_0_0_4px_#d1e9ff] focus:shadow-[0_1px_2px_rgba(16, 24, 40,0.05)]`

export const otpErrorStyles = `border-2 focus:border-[2px]`

export const loaderStyles = `mx-3.5 self-center`
export const otpInputContainerStyles = `w-full`

export const otpFieldLabelStyles = `text-sm-medium mb-2`

export const otpInputFocusStyleStyles = `border-[2px] shadow-[0_1px_2px_rgba(0,0,0,0.08)] outline-none`

export const otpInputErrorStyleStyles = `border-[2px]`

export const otp_InputContainer_Styles = `w-[38px] max-w-[48px] flex-[1] rounded-lg border-[1px] text-sm-medium last-child:!mr-0`

export const minusIconStyles = `ml-3`
